/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./PriceDetails.module.css";

const PriceDetails = ({ total_price, pricingSummaryArray }) => (
    <section className={`${styles.priceDetailsContainer} tw-w-full lg:tw-w-[55%]`}>
        {/* <h2>Pricing</h2> */}
        <div className={styles.pricingSection}>
            {pricingSummaryArray.map((item, index) => (
                <div className={styles.pricingItem}>
                    <p>{item.title}</p>
                    <p className={styles.paymentValue}>{item.value}</p>
                </div>
            ))}
            {/* <div className={styles.pricingItem}>
                <p>Listing charges</p>
                <p className={styles.paymentValue}>${total_price}</p>
            </div> */}
            <div className={styles.totalPaymentContainer}>
                <p>Total Payment</p>
                <p className={styles.paymentValue}>${total_price}</p>
            </div>
        </div>
    </section>
);

export default PriceDetails;
